import { connect } from 'react-redux';
import StatisticsByCountrySegments from './StatisticsByCountrySegments';

const StatisticsByCountrySegmentsComponent = connect(
    function mapStateToProps(state) {
        return {
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByCountrySegments);

export default StatisticsByCountrySegmentsComponent;
